import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  ka: {
    translation: {
      dashboard: 'დაფა',
      catalog: 'კატალოგი',
      circulation: 'გაცემა',
      members: 'წევრები',
      inventory: 'ინვენტარი',
      opac: 'ონლაინ კატალოგი',
      reports: 'ანგარიშები',
      financial: 'ფინანსები',
      accounting: 'საბუღ. ნუსხა',
      accounting_accounts: 'ანგარიშთა გეგმა',
      notifications: 'შეტყობინებები',
      import: 'იმპორტი',
      acquisitions: 'შესყიდვები',
      serials: 'პერიოდიკა',
      branches: 'ფილიალები',
      marc: 'MARC იმპორტი',
      settings: 'პარამეტრები',
      logout: 'გასვლა',
      total_books: 'სულ წიგნი',
      physical_copies: 'ფიზიკური ასლები',
      total_members: 'წევრები',
      active_checkouts: 'გაცემული',
      overdue: 'ვადაგადაცილებული',
      recent_checkouts: 'ბოლო გაცემები',
      no_overdue: 'ვადაგადაცილებული არ არის ✓',
      search_books: 'მოძებნე სათაური, ავტორი, ISBN...',
      search_members: 'მოძებნე სახელი, ელ-ფოსტა...',
      add_book: 'წიგნის დამატება',
      add_member: 'წევრის დამატება',
      title: 'სათაური',
      author: 'ავტორი',
      collection: 'კოლექცია',
      available: 'ხელმისაწვდომი',
      username: 'მომხმარებელი',
      password: 'პაროლი',
      sign_in: 'შესვლა',
      signing_in: 'შესვლა...',
      invalid_credentials: 'არასწორი მომხმარებელი ან პაროლი',
      book: 'წიგნი',
      member: 'წევრი',
      checked_out: 'გაცემის თარიღი',
      due_date: 'დაბრუნების ვადა',
      status: 'სტატუსი',
      returned: 'დაბრუნდა',
      active: 'აქტიური',
      prev: 'წინა',
      next: 'შემდეგი',
      page: 'გვერდი',
      of: '-დან',
      books: 'წიგნი',
      start_session: 'სესიის დაწყება',
      finish_session: 'სესიის დასრულება',
      scan_barcode: 'შტრიხკოდის სკანირება',
      scan_or_type: 'სკანირება ან აკრიფეთ...',
      scan: 'სკანირება',
      scanned: 'სკანირებული',
      items: 'ობიექტი',
      recent_scans: 'ბოლო სკანები',
      no_scans: 'სკანი არ არის',
      start_inventory: 'ინვენტარიზაციის დასაწყებად დააჭირეთ ღილაკს',
      return: 'დაბრუნება',
      name: 'სახელი',
      email: 'ელ-ფოსტა',
      type: 'ტიპი',
      barcode: 'შტრიხკოდი',
      checkouts: 'გაცემები',
      loading: 'იტვირთება...',
      copyright: '© 2026 Kakhaber Revazishvili · SANGU',
    }
  },
  en: {
    translation: {
      dashboard: 'Dashboard',
      catalog: 'Catalog',
      circulation: 'Circulation',
      members: 'Members',
      inventory: 'Inventory',
      opac: 'OPAC',
      reports: 'Reports',
      financial: 'Financial',
      accounting: 'Accounting',
      accounting_accounts: 'Chart of Accounts',
      notifications: 'Notifications',
      import: 'Import',
      acquisitions: 'Acquisitions',
      serials: 'Serials',
      branches: 'Branches',
      marc: 'MARC Import',
      settings: 'Settings',
      logout: 'Logout',
      total_books: 'Total books',
      physical_copies: 'Physical copies',
      total_members: 'Members',
      active_checkouts: 'Active checkouts',
      overdue: 'Overdue',
      recent_checkouts: 'Recent checkouts',
      no_overdue: 'No overdue items ✓',
      search_books: 'Search title, author, ISBN...',
      search_members: 'Search name, email, barcode...',
      add_book: 'Add book',
      add_member: 'Add member',
      title: 'Title',
      author: 'Author',
      collection: 'Collection',
      available: 'Available',
      username: 'Username',
      password: 'Password',
      sign_in: 'Sign in',
      signing_in: 'Signing in...',
      invalid_credentials: 'Invalid username or password',
      book: 'Book',
      member: 'Member',
      checked_out: 'Checked out',
      due_date: 'Due date',
      status: 'Status',
      returned: 'Returned',
      active: 'Active',
      prev: 'Prev',
      next: 'Next',
      page: 'Page',
      of: 'of',
      books: 'books',
      start_session: 'Start session',
      finish_session: 'Finish session',
      scan_barcode: 'Scan barcode',
      scan_or_type: 'Scan or type barcode...',
      scan: 'Scan',
      scanned: 'Scanned',
      items: 'items',
      recent_scans: 'Recent scans',
      no_scans: 'No scans yet',
      start_inventory: 'Start a new inventory session to begin scanning',
      return: 'Return',
      name: 'Name',
      email: 'Email',
      type: 'Type',
      barcode: 'Barcode',
      checkouts: 'Checkouts',
      loading: 'Loading...',
      copyright: '© 2026 Kakhaber Revazishvili · SANGU',
    }
  }
};

i18n.use(initReactI18next).init({
  resources,
  lng: localStorage.getItem('liber_lang') || 'ka',
  fallbackLng: 'en',
  interpolation: { escapeValue: false }
});

export default i18n;
